<template lang="pug">
.modal-card
  header.modal-card-head.px-4.py-3
    p.modal-card-title(data-qa="modal-header") 
      b(v-t="'appointment.abort_event_title'")
    div
      a.button.is-white.is-small(@click="$emit('close')")
        span.icon
          i.mdi.mdi-close.mdi-24px
  section.modal-card-body
    template(v-if="!canBeTerminated")
      p.is-size-6(v-t="'appointment.event_not_empty_warning'")
    template(v-else)
      p.is-size-6(v-t="'appointment.event_cancellation_warning'")
    
  footer.modal-card-foot
    .buttons 
      action-button.is-danger(title="actions.confirm" @click="confirmTerminate" :loading="loading" :disabled="!canBeTerminated")
      button.button(@click="$emit('close')") {{ $t('actions.close') }}
  
</template>

<script>
import {mapActions} from 'vuex'
import APPOINTMENT_STATUS from '../../../constants/appointmentStatus'

export default {
  name: 'EventAbortActions',
  props: {
    appointment: {type: Object, required: true}
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    canBeTerminated() {
      return this.appointment.event.capacity === this.appointment.event.remaining
    }
  },
  methods: {
    ...mapActions('appointments', ['terminateAppointment']),

    async confirmTerminate() {
      if (!this.appointment || this.loading) {
        return
      }
      this.loading = true
      try {
        await this.terminateAppointment({
          appointmentId: this.appointment._id,
          data: {status: APPOINTMENT_STATUS.CANCELED}
        })
        this.$buefy.toast.open({
          message: this.$t(`appointment.update_success.canceled`),
          type: 'is-success',
          queue: false
        })

        this.$emit('terminated')
        this.$emit('close')
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.loading = false
    }
  }
}
</script>
